import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import Ranking from '@/components/Feature/Rankings/Ranking'
import AdSidebar from '@/components/Ads/Sidebar'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { Enfermeria } from '@/components/Feature/Rankings/Output'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Top 10 por Carrera')[0]
    .rankings
  const datalocal = rankings.find(
    item => item.link === '/rankings-por-carrera/enfermeria/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2021`,
        ]}
      />
      <Content>
        <div className="grid sm:gap-4 sm:grid-cols-4">
          <div className="sm:col-span-3">
            <TitleSelector
              pretitle="Ranking de percepción de calidad por carrera:"
              allRankings={rankings}
              section="rankings-por-carrera"
              sectionSlug={datalocal.slug}
            />
            <Columns
              dangerouslySetInnerHTML={{ __html: datalocal.content }}></Columns>
            <Ranking ranking={datalocal.ranking} />
            <Enfermeria />
            <Summary />
          </div>
          <div className="">
            <div className="sticky top-0 pt-6 ">
              <AdSidebar adid={datalocal.adid} slug={datalocal.slug} />
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default IndexPage
